import React from "react";
import Axios from "axios";
import AsyncStorage from '@react-native-async-storage/async-storage';

//context api:  
//https://medium.com/datadriveninvestor/getting-started-w-reacts-context-api-f60aa9be758f

const storeContext = React.createContext();
export const Consumer = storeContext.Consumer;

export class Provider extends React.Component {
	constructor(props) {
		super(props); 
		let restType = this.getRestType(props.router.match.path);
		let route = props.router.match.path;
		let slug = props.router.match.params.slug ? props.router.match.params.slug : '';
		let timer = null;
		this.state = {
			newPage:true,
			slug: slug,
			lastRestType: false,
			restType: restType,
			route: route,
			posts: [], 
			menu: {
				json: null,
			},
			siteLoaded: false,
			pageLoaded: false,
			currentPage: 1, 
			totalPages: 0,      
			appError : '',
			frmMsg: '',
			getMenu: this.getMenu.bind(this),
		};
	}
		
	getMenu(url) {
		
		let self = this;
		let menu = this.state.menu;
		if (menu.json === null) {
			Axios.get(url).then((response)=>{
				menu.json = response.data[0];
				self.setState({
					menu : menu
				});
			}); 
		}
	}
		
	getRestType (path){
		let restType = '';
		switch(path){   
			case '/':
				restType = 'front';
				break; 
			case '/projects/:slug':
				restType = 'project_template';
				break;
			case '/projects/':
				restType = 'projects';
				break; 
			case '/news/':
				restType = 'news';
				break; 
			case '/type/:slug':
				restType = 'type';
				break;  
			case '/project/:slug':
				restType = 'project';
				break;
			default:
				restType = 'post';
			break;
		}
		return restType;
	}

	componentDidMount(){ 
    	this.getPosts(this.buildUrl());      
	}

	componentDidUpdate(prevProps){ 
		if(prevProps.router.location.pathname !== this.props.router.location.pathname){  
			let prev = prevProps.router.location.pathname.split('#')[0];
			let current = this.props.router.location.pathname.split('#')[0];
			if (prev !== current) {
				this.setState({newPage: true});
				let curProps = this.props.router.match;    
				this.setState({
					currentPage : 1, 
					lastRestType: this.state.restType,
					restType : this.getRestType(curProps.path), 
					slug: this.props.router.match.params.slug ? this.props.router.match.params.slug : '',
				},function(){
					this.getPosts(this.buildUrl()); 
				})
			} else {
				this.setState({newPage: false});
			}
			
		} 
	}
	

	buildUrl(){
		let url = '/wp-json/vestbuild/v1/';  
		switch(this.state.restType){   
			case 'front': 
				url += 'front';
				break;  
			case 'projects': 
				url += 'projects';
				break; 
			case 'project_template': 
				url += 'projects/';
				url += this.state.slug
				break; 
			case 'news': 
				url += 'news';
				break; 
			case 'type': 
				url += 'type/';
				url += this.state.slug
				break; 
			case 'project': 
				url += 'project/';
				url += this.state.slug
				break; 
			case 'page': 
				default: 
				url += 'page/';
				url += this.state.slug
				break;  
			
				      
		}
		return url;
	}

	getPosts (url){
		
		let menu = this.state.menu;
		menu.open = false;
		this.setState({
			pageLoaded:false,
			menu:menu
		});
		if ((this.state.lastRestType === 'type' && this.state.restType === 'projects') || (this.state.lastRestType === 'projects' && this.state.restType === 'type') || (this.state.lastRestType === 'type' && this.state.restType === 'type') ) {
			this.setState({
				pageLoaded:true,
				menu:menu
			});
		} else {
			this.setState({
				pageLoaded:false,
				menu:menu
			});
		}
		let self = this;
		
		document.body.classList.remove('state-enquire-open');
	    document.body.classList.remove('state-menu-open');
		Axios.get(url).then((response)=> {
			self.setState({
				posts : response.data, 
				totalPages : response.headers['x-wp-totalpages']
			},function(){     
				if (this.state.siteLoaded == false) {
					setTimeout(() => this.setState({
						siteLoaded : true,
					}), 2500);
					setTimeout(() => this.setState({
						pageLoaded : true,
					}), 2900);
				} else {
					document.body.classList.remove('state-header-transparent');
					document.body.classList.remove('state-header-charcoal');
					document.body.classList.remove('state-header-cream');
					this.setState({
						pageLoaded : true,
					});
					setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
				}     
				
			});
		}).catch(function(error){
			self.appError = 'An unexpected error occurred';
		});  
	}

	render() {
    	return (
			<storeContext.Provider value={this.state}>
				{this.props.children}
			</storeContext.Provider>
		);
	}
}